export type NotificationLogType = "MANUAL" | "AUTOMATIC";
export type NotificationLogChannel = "PUSH" | "IN_APP";
export type NotificationLogStatus = "SENT" | "PARTIAL" | "FAILED" | "NO_RECIPIENTS";
export type NotificationRecipientStatus = "SENT" | "NO_TOKEN" | "FAILED";

export type NotificationTriggerRule =
  | "spot_available"
  | "viewed_not_saved"
  | "saved_event_reminder"
  | "slot_opened";

export interface NotificationLogItem {
  id: string;
  tenantId: string;
  channel: NotificationLogChannel;
  type: NotificationLogType;
  triggerRule: NotificationTriggerRule | null;
  title: string;
  body: string;
  sentBy: string | null;
  segmentCriteria: Record<string, unknown> | null;
  recipientsCount: number;
  status: NotificationLogStatus;
  sentAt: string;
}

export interface NotificationLogsResult {
  items: NotificationLogItem[];
  total: number;
  page: number;
  pages: number;
}

export interface NotificationLogsQueryParams {
  page: number;
  limit: number;
  search?: string;
  type?: NotificationLogType;
  channel?: NotificationLogChannel;
  triggerRule?: NotificationTriggerRule;
  dateFrom?: string;
  dateTo?: string;
}

export interface NotificationLogRecipientItem {
  id: number;
  userId: number;
  userName: string | null;
  userEmail: string | null;
  status: NotificationRecipientStatus;
  failureReason: string | null;
  createdAt: string;
}

export interface NotificationLogRecipientsResult {
  items: NotificationLogRecipientItem[];
  total: number;
  page: number;
  pages: number;
}

export interface NotificationLogRecipientsQueryParams {
  id: string;
  page: number;
  limit: number;
  status?: NotificationRecipientStatus;
}

export const TRIGGER_RULE_LABELS: Record<NotificationTriggerRule, string> = {
  spot_available: "Quedan cupos",
  viewed_not_saved: "Vio y no guardó",
  saved_event_reminder: "Recordatorio de guardado",
  slot_opened: "Se liberó un cupo",
};

export const RECIPIENT_STATUS_LABELS: Record<NotificationRecipientStatus, string> = {
  SENT: "Enviada",
  NO_TOKEN: "Sin dispositivo",
  FAILED: "Falló",
};

export const NOTIFICATION_STATUS_LABELS: Record<NotificationLogStatus, string> = {
  SENT: "Enviada",
  PARTIAL: "Parcial",
  FAILED: "Falló",
  NO_RECIPIENTS: "Sin destinatarios",
};

export type NotificationReportGranularity = "day" | "week" | "month";

export interface NotificationReportTotals {
  notifications: number;
  manual: number;
  automatic: number;
  recipients: number;
  sent: number;
  noToken: number;
  failed: number;
  failureRate: number;
}

export interface NotificationReportVolumeBucket {
  period: string;
  total: number;
  manual: number;
  automatic: number;
}

export interface NotificationReportRuleBreakdown {
  type: NotificationLogType;
  triggerRule: NotificationTriggerRule | null;
  notifications: number;
  recipients: number;
  sent: number;
  noToken: number;
  failed: number;
  failureRate: number;
}

export interface NotificationReport {
  totals: NotificationReportTotals;
  volume: NotificationReportVolumeBucket[];
  byRule: NotificationReportRuleBreakdown[];
}

export interface NotificationReportQueryParams {
  dateFrom: string;
  dateTo: string;
  granularity: NotificationReportGranularity;
  type?: NotificationLogType;
  triggerRule?: NotificationTriggerRule;
}
